// Ô ngày «năm lạ» + khoảng đảo ngược — bản FE để BÁO NGAY khi gõ / khi duyệt.
//
// Luật gốc ở kernel `business-logic/approvalFormDates.js` (máy chủ Core · Work · Connect chặn lúc gửi
// và gửi lại đơn). Bản này chỉ mang phần CHUNG: năm trong [1900, 2100] + «đến» không trước «từ».
// Luật «ô nghỉ phép / tăng ca / công tác chỉ nhận năm hiện tại ±1» chỉ máy chủ chặn — câu 400 hiện ở toast.
//
// Ca gốc 02/10/2026 (Core APR-2609-290): gõ năm 2 chữ số, ô ngày của Chrome hiểu «26» là năm 0026,
// ba cấp vẫn duyệt ⇒ đơn nghỉ 0026-09-23 → 2026-09-23 ⇒ bảng công tô «KL» kín mọi tháng.

import { evaluateVisible } from './utils';

export const DATE_MIN_YEAR = 1900;
export const DATE_MAX_YEAR = 2100;
// Cho thuộc tính min/max của <input>: lịch chọn ngày không đi ra ngoài khoảng này.
export const DATE_INPUT_BOUNDS = { min: `${DATE_MIN_YEAR}-01-01`, max: `${DATE_MAX_YEAR}-12-31` };
export const DATETIME_INPUT_BOUNDS = { min: `${DATE_MIN_YEAR}-01-01T00:00`, max: `${DATE_MAX_YEAR}-12-31T23:59` };

const isBlank = (v) => v === undefined || v === null || v === '';

/** Năm của giá trị ô ngày; null = trống / không đọc được. */
export function dateValueYear(v) {
  if (isBlank(v)) return null;
  const m = /^\s*\+?(\d{4,6})-\d{2}-\d{2}/.exec(String(v));
  if (m) return Number(m[1]);
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? null : d.getUTCFullYear();
}

const badYear = (v) => {
  const y = dateValueYear(v);
  return y !== null && (y < DATE_MIN_YEAR || y > DATE_MAX_YEAR) ? y : null;
};

/**
 * Vấn đề của MỘT ô ngày với giá trị hiện tại.
 * @returns {null | {code: 'invalid_year', year: number} | {code: 'end_before_start'}}
 */
export function dateFieldIssue(field, value) {
  if (!field || isBlank(value)) return null;
  if (field.type === 'date') {
    const y = badYear(value);
    return y === null ? null : { code: 'invalid_year', year: y };
  }
  if ((field.type === 'date_range' || field.type === 'time_range') && typeof value === 'object') {
    const y = badYear(value.from) ?? badYear(value.to);
    if (y !== null) return { code: 'invalid_year', year: y };
    const a = isBlank(value.from) ? NaN : new Date(value.from).getTime();
    const b = isBlank(value.to) ? NaN : new Date(value.to).getTime();
    if (!Number.isNaN(a) && !Number.isNaN(b) && b < a) return { code: 'end_before_start' };
  }
  return null;
}

/** Mọi ô ngày đang HIỆN có vấn đề: [{ field, issue }]. */
export function findDateIssues(fields, formData) {
  const data = formData || {};
  return (fields || [])
    .filter(f => f && f.id && evaluateVisible(f.visible_when, data))
    .map(f => ({ field: f, issue: dateFieldIssue(f, data[f.id]) }))
    .filter(x => x.issue);
}
